export default function RealtimeDynamics() {
  const droneStatus = [
    { id: 'UAV001', name: '巡检无人机-01', status: '飞行中', battery: 85, location: '东港海域', task: '油污监测', flightTime: '45min' },
    { id: 'UAV002', name: '巡检无人机-02', status: '飞行中', battery: 72, location: '煤炭码头', task: '粉尘监控', flightTime: '38min' },
    { id: 'UAV003', name: '巡检无人机-03', status: '待命', battery: 100, location: '停机坪A', task: '无', flightTime: '0min' },
    { id: 'UAV004', name: '巡检无人机-04', status: '充电中', battery: 45, location: '停机坪B', task: '无', flightTime: '0min' },
    { id: 'UAV005', name: '巡检无人机-05', status: '飞行中', battery: 68, location: '西港高架桥', task: '设施巡检', flightTime: '32min' },
    { id: 'UAV006', name: '巡检无人机-06', status: '飞行中', battery: 91, location: '南港码头', task: '安防巡逻', flightTime: '28min' },
  ];

  const todayTasks = [
    { id: 'TASK001', name: '东港海域油污监测', type: '环境监测', assignedDrone: 'UAV001', status: '执行中', progress: 75, startTime: '08:30', estimatedEnd: '10:30' },
    { id: 'TASK002', name: '煤炭码头粉尘监控', type: '环境监测', assignedDrone: 'UAV002', status: '执行中', progress: 60, startTime: '09:00', estimatedEnd: '11:00' },
    { id: 'TASK003', name: '西港高架桥巡检', type: '设施巡检', assignedDrone: 'UAV005', status: '执行中', progress: 45, startTime: '09:30', estimatedEnd: '11:30' },
    { id: 'TASK004', name: '南港安防巡逻', type: '安全巡逻', assignedDrone: 'UAV006', status: '执行中', progress: 30, startTime: '10:00', estimatedEnd: '12:00' },
    { id: 'TASK005', name: '散货堆场盘点', type: '生产运营', assignedDrone: '待分配', status: '待执行', progress: 0, startTime: '14:00', estimatedEnd: '16:00' },
    { id: 'TASK006', name: '夜间安防巡逻', type: '安全巡逻', assignedDrone: '待分配', status: '待执行', progress: 0, startTime: '20:00', estimatedEnd: '22:00' },
  ];

  const alertEvents = [
    { id: 'ALERT001', type: '环境预警', level: '高', content: '南港海域D区油污面积达280㎡，超过阈值', time: '14:20', handled: false },
    { id: 'ALERT002', type: '安全预警', level: '中', content: '煤炭码头A区粉尘浓度180μg/m³，超标', time: '08:30', handled: true },
    { id: 'ALERT003', type: '设施预警', level: '高', content: '5号岸桥发现结构裂纹，需紧急处理', time: '15:50', handled: false },
    { id: 'ALERT004', type: '安全预警', level: '低', content: '东港区域发现人员未佩戴安全帽', time: '10:15', handled: true },
    { id: 'ALERT005', type: '环境预警', level: '中', content: '散货堆场C区粉尘浓度220μg/m³，严重超标', time: '10:00', handled: true },
  ];

  return (
    <div className="space-y-6">
      {/* 关键数据统计 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">在线无人机</span>
            <i className="ri-flight-takeoff-line text-2xl text-teal-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">4/6</div>
          <div className="text-xs text-teal-400">飞行中</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">今日任务</span>
            <i className="ri-task-line text-2xl text-blue-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">6</div>
          <div className="text-xs text-blue-400">4个执行中</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">预警事件</span>
            <i className="ri-alarm-warning-line text-2xl text-orange-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">5</div>
          <div className="text-xs text-orange-400">2个待处理</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">累计飞行</span>
            <i className="ri-time-line text-2xl text-green-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">143min</div>
          <div className="text-xs text-green-400">今日累计</div>
        </div>
      </div>

      {/* 无人机实时状态 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-flight-takeoff-line text-teal-400"></i>
          无人机实时状态
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {droneStatus.map((drone) => (
            <div key={drone.id} className="bg-gray-700/30 rounded-lg p-4 border border-gray-600/30">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <i className="ri-flight-takeoff-fill text-teal-400 text-xl"></i>
                  <span className="text-white font-medium text-sm">{drone.name}</span>
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  drone.status === '飞行中' ? 'bg-green-500/20 text-green-400' :
                  drone.status === '待命' ? 'bg-blue-500/20 text-blue-400' :
                  'bg-orange-500/20 text-orange-400'
                }`}>
                  {drone.status}
                </span>
              </div>
              <div className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">电量</span>
                  <div className="flex items-center gap-2">
                    <div className="w-24 h-2 bg-gray-600 rounded-full overflow-hidden">
                      <div 
                        className={`h-full ${
                          drone.battery > 70 ? 'bg-green-400' :
                          drone.battery > 40 ? 'bg-orange-400' :
                          'bg-red-400'
                        }`}
                        style={{ width: `${drone.battery}%` }}
                      ></div>
                    </div>
                    <span className="text-white font-medium">{drone.battery}%</span>
                  </div>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">位置</span>
                  <span className="text-white">{drone.location}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">任务</span>
                  <span className="text-teal-400">{drone.task}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">飞行时长</span>
                  <span className="text-white">{drone.flightTime}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 飞行轨迹地图 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-map-pin-line text-teal-400"></i>
          实时飞行轨迹
        </h3>
        <div className="relative rounded-lg overflow-hidden h-96">
          <img 
            src="https://public.readdy.ai/ai/img_res/99f83e29e1d6a4755feca0f59985d7d3.jpg"
            alt="飞行轨迹图"
            className="w-full h-full object-cover"
          />
          <div className="absolute top-4 right-4 bg-black/80 backdrop-blur-sm rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-green-400 rounded-full"></div>
              <span className="text-white text-sm">UAV001 - 东港海域</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-blue-400 rounded-full"></div>
              <span className="text-white text-sm">UAV002 - 煤炭码头</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-purple-400 rounded-full"></div>
              <span className="text-white text-sm">UAV005 - 西港高架桥</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-orange-400 rounded-full"></div>
              <span className="text-white text-sm">UAV006 - 南港码头</span>
            </div>
          </div>
        </div>
      </div>

      {/* 今日任务列表 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-task-line text-teal-400"></i>
          今日任务列表
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">任务编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">任务名称</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">任务类型</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">分配无人机</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">执行状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">执行进度</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">开始时间</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">预计结束</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {todayTasks.map((task) => (
                <tr key={task.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{task.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{task.name}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{task.type}</td>
                  <td className="py-3 px-4 text-sm text-teal-400">{task.assignedDrone}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      task.status === '执行中' ? 'bg-green-500/20 text-green-400' :
                      'bg-yellow-500/20 text-yellow-400'
                    }`}>
                      {task.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      <div className="w-20 h-2 bg-gray-600 rounded-full overflow-hidden">
                        <div 
                          className="h-full bg-teal-400"
                          style={{ width: `${task.progress}%` }}
                        ></div>
                      </div>
                      <span className="text-white text-sm">{task.progress}%</span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{task.startTime}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{task.estimatedEnd}</td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 预警事件推送 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-alarm-warning-line text-orange-400"></i>
          预警事件实时推送
        </h3>
        <div className="space-y-3">
          {alertEvents.map((event) => (
            <div key={event.id} className="bg-gray-700/30 rounded-lg p-4 border border-gray-600/30 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                  event.level === '高' ? 'bg-red-500/20' :
                  event.level === '中' ? 'bg-orange-500/20' :
                  'bg-yellow-500/20'
                }`}>
                  <i className={`ri-alarm-warning-line text-2xl ${
                    event.level === '高' ? 'text-red-400' :
                    event.level === '中' ? 'text-orange-400' :
                    'text-yellow-400'
                  }`}></i>
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-white font-medium">{event.type}</span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      event.level === '高' ? 'bg-red-500/20 text-red-400' :
                      event.level === '中' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-yellow-500/20 text-yellow-400'
                    }`}>
                      {event.level}级
                    </span>
                  </div>
                  <div className="text-sm text-gray-300 mb-1">{event.content}</div>
                  <div className="text-xs text-gray-400">{event.time}</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                  event.handled ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
                }`}>
                  {event.handled ? '已处理' : '待处理'}
                </span>
                <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                  查看
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}